enum PricingOverrideTypes {
  TargetBuyRate = "TARGET_BUY_RATE",
  TargetSellRate = "TARGET_SELL_RATE",
  TargetSellRpm = "TARGET_SELL_RPM",
}

export default PricingOverrideTypes;
